import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { experiences } from "../constants";
import Footer from "./Footer";
import { motion } from "framer-motion";
import Background from "./Background";

const Experience = () => {
  return (
    <div
      className="experience bg-black w-screen text-white pt-8 h-full w-full-x-hidden"
      id="experience"
    >
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <div className="pt-12 sm:px-16">
        <p className="font-light">MY JOURNEY SO FAR.</p>
        <h2 className="text-4xl sm:text-5xl font-extrabold mt-2">
          Work Experience.
        </h2>
      </div>
      <VerticalTimeline className="mt-9">
        {experiences.map((experience) => (
          <VerticalTimelineElement
            className="relative vertical-timeline-element--work"
            contentStyle={{ background: "#1d1836", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  #232631" }}
            date={experience.duration}
            iconStyle={{ background: "#fff" }}
            icon={
              <a
                className="flex justify-center items-center w-full h-full"
                href={experience.url}
                target="_blank"
              >
                <img
                  src={experience.logo}
                  alt={experience.company}
                  className="w-[60%] h-[60%] object-contain"
                />
              </a>
            }
          >
            <div>
              <h3 className="text-white text-[24px] font-bold">
                {experience.role}
              </h3>
              <p
                className="text-secondary text-[16px] font-semibold"
                style={{ margin: 0 }}
              >
                {experience.company}
              </p>
            </div>

            <ul className="mt-5 list-disc ml-5 space-y-2">
              {experience.points.map((point, index) => (
                <li
                  key={`experience-point-${index}`}
                  className="text-white-100 text-[14px] pl-1 tracking-wider"
                >
                  {point}
                </li>
              ))}
            </ul>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
      <Footer />
    </div>
  );
};

export default Experience;
